import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { PledgeCampaignDto } from '../../shared/pledge-campaign/dto/pledge-campaign.dto';
import { PledgeCampaignService } from '../../shared/pledge-campaign/pledge-campaign.service';
import { NotificationService, TranslationService } from 'src/app/shared';
import { NgForm } from '@angular/forms';
import { ObservationService } from 'src/app/shared/observation/observation.service';
import { SecurityElementNames } from 'src/app/shared/auth/constants/security-element-names.service';
import { Title } from '@angular/platform-browser';
import { MenuItem } from 'primeng/api';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { PledgeCampaignDetailsEditComponent } from './pledge-campaign-details-edit/pledge-campaign-details-edit.component';
import { PledgeCampaignPledgesComponent } from './pledge-campaign-pledges/pledge-campaign-pledges.component';

@Component({
  selector: 'wl-pledge-campaign-edit',
  templateUrl: './pledge-campaign-edit.component.html',
  styleUrls: ['./pledge-campaign-edit.component.less'],
    standalone: false
})
export class PledgeCampaignEditComponent implements OnInit, OnDestroy {
  @ViewChild('detailsForm') detailsForm: NgForm;
  @ViewChild(PledgeCampaignDetailsEditComponent) private _campaignDetailsComponent: PledgeCampaignDetailsEditComponent;
  @ViewChild(PledgeCampaignPledgesComponent) private _pledgesComponent: PledgeCampaignPledgesComponent;

  pledgeCampaignId: number;
  pledgeCampaign: PledgeCampaignDto;
  isSaving: boolean;
  public actionsText: string;
  public actionsOptions: MenuItem[];

  private subs = new Subscription();
  constructor(
    public securityElementNames: SecurityElementNames,
    private _route: ActivatedRoute,
    private _router: Router,
    private _pledgeCampaignService: PledgeCampaignService,
    private _notificationService: NotificationService,
    private _translationService: TranslationService,
    private _navigationService: NavigationService,
    private _title: Title
  ) {}

  ngOnInit(): void {
    this.subs.add(
      this._route.params.subscribe((params) => {
        if (params.pledgeCampaignId) {
          this.pledgeCampaignId = params.pledgeCampaignId;
          this.loadPledgeCampaign();
        }
      })
    );
    this.initActionsOptions();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  save() {
    this.isSaving = true;
    this._pledgeCampaignService
      .updatePledgeCampaign(this.pledgeCampaign)
      .then(() => {
        this._notificationService.translateSuccess('revenue.pledge-campaigns.pledge-campaign.edit.saved-successfully');
        this._campaignDetailsComponent.progressBarComponent.configureComponentData();
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      })
      .finally(() => {
        this.isSaving = false;
        this.detailsForm?.form.markAsPristine();
      });
  }

  cancel() {
    if (this._router.getCurrentNavigation()?.previousNavigation.finalUrl) {
      this._router.navigateByUrl(this._router.getCurrentNavigation().previousNavigation.finalUrl);
    } else {
      this._router.navigate(['revenue/pledge-campaigns']);
    }
  }

  private loadPledgeCampaign() {
    this._pledgeCampaignService.getPledgeCampaign(this.pledgeCampaignId).then((pledgeCampaign: PledgeCampaignDto) => {
      this.pledgeCampaign = pledgeCampaign;
      this._title.setTitle(pledgeCampaign.CampaignName);
    });
  }

  private campaignReport() {
    this._navigationService.navigateRevenuePledgeCampaignTotalsReport(this.pledgeCampaign.PledgeCampaignId);
  }

  public reloadProgressBarComponent(reload: boolean) {
    if (reload) {
      this._campaignDetailsComponent.progressBarComponent.configureComponentData();
    }
  }

  private initActionsOptions() {
    let p1 = this._translationService.get('revenue.invoice-selector.actions.label');
    let p2 = this._translationService.get('revenue.pledge-campaigns.actions.campaign-report');
    let p3 = this._translationService.getTitlecase('revenue.pledge-campaigns.actions.export-pledges');

    Promise.all([p1, p2, p3]).then((data: string[]) => {
      this.actionsText = data[0];
      this.actionsOptions = [
        {
          label: data[1],
          command: () => {
            this.campaignReport();
          },
        },
        {
          label: data[2],
          command: () => {
            this._pledgesComponent.exportPledges();
          },
        },
      ];
    });
  }
}
